import { useEffect, useState } from 'react';

import { toTopicViewModel } from '@/adapters/topic-adapter';
import type { Topic } from '@/models/topic';
import { getActiveTopics } from '@/services/topic-service';
import { useBrowserQueryCache } from '@/lib/query-cache/use-browser-query-cache';

type TopicsState = {
  status: 'loading' | 'success' | 'error';
  topics: Topic[];
  error?: string;
};

export function useTopics(enabled = true): TopicsState {
  const queryCache = useBrowserQueryCache();
  const [state, setState] = useState<TopicsState>({
    status: 'loading',
    topics: [],
  });

  useEffect(() => {
    if (!enabled) {
      return;
    }

    let active = true;

    getActiveTopics({ cache: queryCache })
      .then((docs) => {
        if (!active) {
          return;
        }

        setState({
          status: 'success',
          topics: docs
            .map(toTopicViewModel)
            .sort((left, right) => left.label.localeCompare(right.label, 'pt-BR')),
        });
      })
      .catch(() => {
        if (!active) {
          return;
        }

        setState({
          status: 'error',
          topics: [],
          error: 'Não foi possível carregar os temas agora.',
        });
      });

    return () => {
      active = false;
    };
  }, [enabled, queryCache]);

  return state;
}
